import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '@/app/routes/ProtectedRoute';
import { AdminLayout } from './AdminLayout';
import { AdminHomePage } from './screens/home/AdminHomePage';
import { AdminLoginPage } from './screens/login/AdminLoginPage';
import { AdminResetPasswordPage } from './screens/reset-password/AdminResetPasswordPage';
import { AdminSignupPage } from './screens/signup/AdminSignupPage';
import { AdminTermsPage } from './screens/terms/AdminTermsPage';
import { AdminPrototypePage } from './screens/_shared/AdminPrototypePage';
import { prototypePageConfigs } from './screens/_shared/prototypeData';
import { RoleManagementPage } from './screens/role-management/RoleManagementPage';
import { AdminManagementPage } from './screens/admin-management/AdminManagementPage';
import { MedicalStaffManagementPage } from './screens/medical-staff-management/MedicalStaffManagementPage';
import { StaffInviteEmailPage } from './screens/staff-invite-email/StaffInviteEmailPage';
import { StaffPasswordResetEmailPage } from './screens/staff-password-reset-email/StaffPasswordResetEmailPage';
import { StaffWithdrawResultEmailPage } from './screens/staff-withdraw-result-email/StaffWithdrawResultEmailPage';
import { TermsManagementPage } from './screens/terms-management/TermsManagementPage';
import { AdminInviteEmailPage } from './screens/admin-invite-email/AdminInviteEmailPage';
import { AdminPasswordResetEmailPage } from './screens/admin-password-reset-email/AdminPasswordResetEmailPage';
import { PatientManagementPage } from './screens/patient-management/PatientManagementPage';
import { DiseaseCodeManagementPage } from './screens/disease-code-management/DiseaseCodeManagementPage';
import { ManagementGuidelinesPage } from './screens/management-guidelines/ManagementGuidelinesPage';
import { CounselingManualPage } from './screens/counseling-manual/CounselingManualPage';
import { MyProfilePage } from './screens/my-profile/MyProfilePage';
import { BiometricDataPage } from './screens/biometric-data/BiometricDataPage';
import { HealthEncyclopediaPage } from './screens/health-encyclopedia/HealthEncyclopediaPage';
import { ProDeploymentPage } from './screens/pro-deployment-management/ProDeploymentPage';

import { LogInquiryPage } from './screens/log-inquiry/LogInquiryPage';
import { ProItemDesignPage } from './screens/pro-item-design/ProItemDesignPage';
import { QuestionnaireDesignPage } from './screens/questionnaire-design/QuestionnaireDesignPage';
import { NoticeManagementPage } from './screens/notice-management/NoticeManagementPage';
import { NotificationSettingsPage } from './screens/notification-settings/NotificationSettingsPage';
import { PatientInquiryManagementPage } from './screens/patient-inquiry-management/PatientInquiryManagementPage';
// TODO(coming-soon-bypass): Temporary imports — remove together with the
// isBypassed() ternaries below to restore real pages.
import { AdminComingSoonPage } from './screens/_shared/AdminComingSoonPage';
import { TEMP_ALL_MENU_TO_COMING_SOON, TEMP_ENABLED_PATHS } from './_temp/comingSoonConfig';

const isBypassed = (path: string) =>
  TEMP_ALL_MENU_TO_COMING_SOON && !TEMP_ENABLED_PATHS.includes(path);

export function AdminRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLoginPage />} />
      <Route path="/signup" element={<AdminSignupPage />} />
      {/* Public legal-terms viewer (FEATURE_041) — reachable pre-login from login/signup footer. */}
      <Route path="/terms" element={<AdminTermsPage />} />
      <Route path="/reset-password" element={<AdminResetPasswordPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route
            path="/home"
            element={isBypassed('/home') ? <AdminComingSoonPage /> : <AdminHomePage />}
          />
          <Route
            path="/role-management"
            element={
              isBypassed('/role-management') ? <AdminComingSoonPage /> : <RoleManagementPage />
            }
          />
          <Route
            path="/admin-management"
            element={
              isBypassed('/admin-management') ? <AdminComingSoonPage /> : <AdminManagementPage />
            }
          />
          <Route
            path="/patient-management"
            element={
              isBypassed('/patient-management') ? (
                <AdminComingSoonPage />
              ) : (
                <PatientManagementPage />
              )
            }
          />
          <Route
            path="/medical-staff-management"
            element={
              isBypassed('/medical-staff-management') ? (
                <AdminComingSoonPage />
              ) : (
                <MedicalStaffManagementPage />
              )
            }
          />
          <Route
            path="/disease-code"
            element={
              isBypassed('/disease-code') ? (
                <AdminComingSoonPage />
              ) : (
                <DiseaseCodeManagementPage />
              )
            }
          />
          <Route
            path="/terms-and-conditions-management"
            element={
              isBypassed('/terms-and-conditions-management')
                ? <AdminComingSoonPage />
                : <TermsManagementPage />
            }
          />
          <Route
            path="/management-guidelines"
            element={
              isBypassed('/management-guidelines') ? (
                <AdminComingSoonPage />
              ) : (
                <ManagementGuidelinesPage />
              )
            }
          />
          <Route
            path="/counseling-manual"
            element={
              isBypassed('/counseling-manual') ? (
                <AdminComingSoonPage />
              ) : (
                <CounselingManualPage />
              )
            }
          />
          <Route
            path="/my-profile"
            element={
              isBypassed('/my-profile') ? (
                <AdminComingSoonPage />
              ) : (
                <MyProfilePage />
              )
            }
          />
          <Route
            path="/biometric-data"
            element={
              isBypassed('/biometric-data') ? (
                <AdminComingSoonPage />
              ) : (
                <BiometricDataPage />
              )
            }
          />
          <Route
            path="/log-inquiry"
            element={
              isBypassed('/log-inquiry') ? (
                <AdminComingSoonPage />
              ) : (
                <LogInquiryPage />
              )
            }
          />
          <Route
            path="/pro-item-design"
            element={
              isBypassed('/pro-item-design') ? (
                <AdminComingSoonPage />
              ) : (
                <ProItemDesignPage />
              )
            }
          />
          <Route
            path="/questionnaire-design"
              element={
                isBypassed('/questionnaire-design') ? (
                  <AdminComingSoonPage />
                ) : (
                  <QuestionnaireDesignPage />
                )
              }
          />
          <Route
            path="/health-encyclopedia"
            element={
              isBypassed('/health-encyclopedia') ? (
                <AdminComingSoonPage />
              ) : (
                <HealthEncyclopediaPage />
              )
            }
          />
          <Route
            path="/pro-deployment-management"
            element={
              isBypassed('/pro-deployment-management') ? (
                <AdminComingSoonPage />
              ) : (
                <ProDeploymentPage />
              )
            }
          />
          <Route
            path="/notice-management"
            element={
              isBypassed('/notice-management') ? (
                <AdminComingSoonPage />
              ) : (
                <NoticeManagementPage />
              )
            }
          />
          <Route
              path="/patient-inquiry-management"
            element={
              isBypassed('/patient-inquiry-management') ? (
                <AdminComingSoonPage />
              ) : (
                <PatientInquiryManagementPage />
              )
            }
          />
          <Route
            path="/notification-settings"
            element={
              isBypassed('/notification-settings') ? (
                <AdminComingSoonPage />
              ) : (
                <NotificationSettingsPage />
              )
            }
          />
          {prototypePageConfigs.map((config) => (
            <Route
              key={config.path}
              path={config.path}
              element={
                isBypassed(config.path) ? <AdminComingSoonPage /> : <AdminPrototypePage />
              }
            />
          ))}
          <Route path="/" element={<Navigate to="/home" replace />} />
        </Route>
        {/* Chromeless email-preview pages — protected but rendered without GNB/sidebar,
            matching prototype/pages/{admin,staff}-{invite,password-reset}-email.html. */}
        <Route path="/admin-invite-email" element={<AdminInviteEmailPage />} />
        <Route
          path="/admin-password-reset-email"
          element={<AdminPasswordResetEmailPage />}
        />
        <Route path="/staff-invite-email" element={<StaffInviteEmailPage />} />
        <Route
          path="/staff-password-reset-email"
          element={<StaffPasswordResetEmailPage />}
        />
        <Route
          path="/staff-withdraw-result-email"
          element={<StaffWithdrawResultEmailPage />}
        />
      </Route>
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}
